import React from 'react';
import { Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

const SearchButton = props => {
    return (
        <Button outline id="advanceSearchButton" color="primary" style={{ width: 180 }} onClick={() => props.search()}>
            <span style={{ display: 'flex', paddingLeft: 10 }} >
                <MaterialIcon icon="search" color="#0288D1" size={28} />
            </span>
            {i18n.t('common:searchForms.search')}
        </Button>
    );
}

export default SearchButton;


// WEBPACK FOOTER //
// ./src/components/common/SearchButton.js